import request from '@/router/axios'
import {getWxCodeMa} from '@/api/insurance/policy'
import {centerObjectPost} from 'meibao-insure/src/api/productCenterNew'

export function fetchList(query) {
	return request({
		url: '/dist/distProduct/list',
		method: 'get',
		params: query,
	})
}

export function getProductList(query) {
	return request({
		url: '/dist/distProduct/listInfo',
		method: 'get',
		params: query,
	})
}

//收藏列表
export function getCollectList() {
	return request({
		url: '/dist/distProduct/favorites',
		method: 'get',
	})
}

//收藏排序
export function collectProductSort(productIds) {
	return request({
		url: `/dist/distProduct/favorites/${productIds}`,
		method: 'put',
	})
}

//收藏/取消收藏
export function collectProduct(id) {
	return request({
		url: `/dist/distProduct/favorite/${id}`,
		method: 'put',
	})
}

export function getProductListAll(query) {
	return request({
		url: '/dist/distProduct/listInfoAll',
		method: 'get',
		params: query,
	})
}

export function getProductPrice(query) {
	return request({
		url: '/dist/distProduct/price',
		method: 'get',
		params: query,
	})
}

export function getProfessionHistory(id, query) {
	return request({
		url: '/dist/distProduct/professHistory/' + id,
		method: 'get',
		params: query,
	})
}

export function isAddOrEditAddress(data, method = 'post') {
	return request({
		url: '/dist/recipient',
		method,
		data,
	})
}

//获取邮寄地址 /recipient/myList
export function getAddressMyList() {
	return request({
		url: '/dist/recipient/myList',
		method: 'get',
	})
}

//获取邮寄地址
export function getAddressByChannelId(id) {
	return request({
		url: `/dist/recipient/channel/${id}`,
		method: 'get',
	})
}

export function getErrorIdAuth(query) {
	return request({
		url: '/dist/idAuth/page',
		method: 'get',
		params: query,
	})
}

//获取验证码
export function getCode() {
	return centerObjectPost('/service/captcha')
}

//保单稽查
export function checkPolicyTruth(data) {
	return centerObjectPost('/service/policy/verify', data)
}

//获取分享码
export function getShareCode() {
	return request({
		url: '/dist/distAccount/shareCode',
		method: 'get',
	})
}

//生成分享二维码
export function getShareQrcode({id, insureType: iT, productIdCenter: pc = ''}) {
	return new Promise(async (resolve, reject) => {
		let shareCode = (await getShareCode()) || {}
		let {code, data = ''} = shareCode.data || {}
		if (code !== 0 || !data) {
			reject()
		}
		console.log(process.env.NODE_ENV, 'process.env.NODE_ENV---')
		let appId = process.env.NODE_ENV === 'production' ? 'wx5c335eed0afec390' : 'wx8b1ea66404077193'
		//获取code后再次获取二维码
		let wxCode = (await getWxCodeMa(`id=${id}&iT=${iT}&pc=${pc}&sc=${data}`, appId, 1)) || {}
		let {code: code2, data: data2 = ''} = wxCode.data || {}
		if (code2 !== 0 || !data2) {
			reject()
		}
		resolve(data2)
	})
}

//通过产品中心不变的ID，获取数据 "contextType": 1,
// "productId": 1034  /v2/product/contextInfo
export function getProductDataByCenterId(productId) {
	return centerObjectPost('/v2/product/contextInfo', {productId, contextType: 1})
}
